<script lang="ts" setup>
import { Employee } from '../../components/EmployeeSingle.vue'

defineProps<{
  title: string
  persons: Employee[]
  hideImages?: boolean
}>()
</script>

<template>
  <ToccoContactPersons :title="title" :persons="persons" :hide-images="hideImages" />
</template>
